import { Component, Input, OnInit } from '@angular/core';
import { Http } from '@angular/http';

var htmlToText = require('html-to-text');

export interface ListItem {
    title?: string;
    link?: string;
    content?: string;
}

@Component({
    selector: 'list-item',
    templateUrl: 'list-item.component.html',
    styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent implements OnInit {
    @Input() item;
    trunc_item_content;

    constructor(private http: Http) { }

    ngOnInit() {
        this.trunc_item_content = htmlToText.fromString(this.item.content, {
            wordwrap: 80,
            ignoreHref: true,
            ignoreImage: true
        });
        //console.log(this.trunc_item_content);
        this.trunc_item_content = this.text_truncate(this.trunc_item_content, 300, '... ') + ' <a>(lire la suite)</a>';
    }

    text_truncate(str, length, ending) {
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/list-item/list-item.component.ts